import React from "react";
import PropTypes from "prop-types";
import "./HeroSection.css"; // Link to your CSS file for the section styles

function HeroSection({ heading, punchline, backgroundImage }) {
  return (
    <div
      className="hero-section"
      style={{
        backgroundImage: `url(${backgroundImage})`, // Inline background image
      }}
    >
      <div className="hero-content">
        <h1 className="hero-heading">{heading}</h1>
        </div>
        <div>
        {punchline && <p className="hero-punchline">{punchline}</p>} {/* Conditional rendering of punchline */}
      </div>
    </div>
  );
}

HeroSection.propTypes = {
  heading: PropTypes.string.isRequired,
  punchline: PropTypes.string, // Optional punchline prop
  backgroundImage: PropTypes.string.isRequired,
};

export default HeroSection;
 